import type { Pot } from "@/types";

/** Minimal shape needed to decide a plant's visual: its photo and species label. */
interface PlantImageInput {
  photoImageUrl?: string | null;
  species?: { labelImageUrl?: string | null } | null;
}

/**
 * True when a plant has a user-supplied photo that differs from its species'
 * scanned label image — i.e. a genuine photo worth showing instead of the
 * colored initial tile. Shared by `PlantMark`, pot covers, and detail headers
 * so every surface agrees on what counts as a photo.
 */
export function plantHasDistinctPhoto(plant: PlantImageInput): boolean {
  const labelImageUrl = plant.species?.labelImageUrl ?? null;
  return !!plant.photoImageUrl && plant.photoImageUrl !== labelImageUrl;
}

/**
 * Cover photo for a pot, or null. A pot holding exactly one plant borrows that
 * plant's distinct photo as its visual; multi-plant pots (or plants without a
 * photo) fall back to the procedural pot illustration.
 */
export function potCoverPhotoUrl(pot: Pot): string | null {
  if (pot.plants.length !== 1) return null;
  const plant = pot.plants[0]!;
  return plantHasDistinctPhoto(plant) ? plant.photoImageUrl! : null;
}
